import NoDetailSvg from '../../../../../components/svgs/NoDetails';

export const ReportsEmptyState = () => {
	return (
		<div className="text-center">
			<div className="flex justify-center mb-3">
				<NoDetailSvg />
			</div>

			<span className="font-semibold text-[#000000] text-[0.95em]">No detail</span>
		</div>
	);
};
